import { isMobile } from 'react-device-detect';
import env from '../config/env';

export const option = {
  mobile: 'mobile',
  local: 'local',
  dev: 'dev',
  staging: 'staging',
  prod: 'prod',
  log: 'log',
  warn: 'warn',
  error: 'error',
};

export const perLogger = {
  log: (message, { ignore = [], consoleMode }) =>
    perLog(message, { ignore: ignore, consoleMode: consoleMode }),
  warn: (message, { ignore = [], consoleMode }) =>
    perLog(message, {
      ignore: ignore,
      level: option.warn,
      consoleMode: consoleMode,
    }),
  error: (message, { ignore = [], consoleMode }) =>
    perLog(message, {
      ignore: ignore,
      level: option.error,
      consoleMode: consoleMode,
    }),
};

const perLog = (message, { ignore = [], level = option.log, consoleMode }) => {
  if (isMobile) {
    if (ignore.includes(option.mobile)) {
      return;
    }
    if (env.isLocal && ignore.includes(option.local)) {
      return;
    }
    if (env.isDev && ignore.includes(option.dev)) {
      return;
    }
    if (!env.isDev && ignore.includes(option.prod)) {
      return;
    }
    if (consoleMode) {
      if (level === option.warn) {
        console.warn(message);
        return;
      }
      if (level === option.error) {
        console.error(message);
        return;
      }

      console.log(message);
      return;
    }

    alert(message);
    return;
  }

  if (env.isLocal && ignore.includes(option.local)) {
    return;
  }
  if (env.isDev && ignore.includes(option.dev)) {
    return;
  }
  if (!env.isDev && ignore.includes(option.prod)) {
    return;
  }
  if (level === option.warn) {
    console.warn(message);
    return;
  }
  if (level === option.error) {
    console.error(message);
    return;
  }

  console.log(message);
};
